import { render, staticRenderFns } from "./memberships_by_plan_table.vue?vue&type=template&id=331540f7&"
import script from "./memberships_by_plan_table.vue?vue&type=script&lang=js&"
export * from "./memberships_by_plan_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports